window.addEventListener("DOMContentLoaded", function () {
  window.addEventListener("scroll", scrolling);
  window.addEventListener("keyup", keyPress);
  document.querySelectorAll(".open-cart-link").forEach((el) => {
    el.addEventListener("click", () =>
      document.documentElement.classList.add("cart-drawer"),
    )
  })
  document.addEventListener('click', function (event) {
    const openPopup = document.querySelector('.product-card-pop:not(.hidden)')
    const isTrigger = event.target.closest('.product-card-pop-trigger')
    if (!openPopup || isTrigger) return
    if (!openPopup.contains(event.target)) openPopup.classList.add('hidden')
  })
  // Safari iOS affiche la pop-in d'ajout rapide (fixed dans un carrousel qui défile) sous les sections suivantes :
  // en mobile, on la passe dans le top layer (API popover) tant qu'elle est ouverte.
  if (HTMLElement.prototype.showPopover) {
    const mobile = window.matchMedia('(max-width: 1023px)')
    new MutationObserver((mutations) => {
      mutations.forEach(({ target }) => {
        if (!target.classList.contains('product-card-pop')) return
        const open = !target.classList.contains('hidden')
        if (open && mobile.matches && !target.matches(':popover-open')) {
          target.popover = 'manual'
          target.showPopover()
        } else if (!open && target.hasAttribute('popover')) {
          if (target.matches(':popover-open')) target.hidePopover()
          target.removeAttribute('popover')
        }
      })
    }).observe(document.body, { subtree: true, attributes: true, attributeFilter: ['class'] })
  }
});

function keyPress(e) {
  if (e.code == "Escape") {
    if (document.querySelector("html.cart-drawer"))
      document.documentElement.classList.remove("cart-drawer");
    if (document.querySelector(".avis-pop:not(.hidden)"))
      document.querySelector(".avis-pop").classList.add("hidden");
  }
}

/*
function manage_return_to() {
  const loginForm = document.querySelector('#customer_login')
  if (loginForm) {
    const urlParams = new URLSearchParams(window.location.search)
    const returnTo = urlParams.get('return_to')
    if(returnTo) {
      const returnToInput = document.createElement('input')
      returnToInput.type = 'hidden'
      returnToInput.name = 'return_to'
      returnToInput.value = returnTo
      loginForm.appendChild(returnToInput)
    }
  }
}
*/

window.addEventListener('pageshow', function(event) {
  // event.persisted est vrai si la page est chargée depuis le bfcache
  if (event.persisted) {
    window.updateCart()
    console.log("Page chargée depuis le bfcache, mise à jour du panier via AJAX");
  }
});

function addToCart(e) {
  e.preventDefault();

  e.target.querySelector('[type="submit"]').disabled = true;

  let formData = Object.fromEntries(new FormData(e.target));
  // console.log(formData)
  let properties = {};
  for (const key in formData) {
    if (key.startsWith("properties[")) {
      let propName = key.match(/properties\[(.*?)\]/)[1];
      properties[propName] = formData[key];
      delete formData[key];
    }
  }
  if (Object.keys(properties).length > 0) formData.properties = properties;

  fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: "POST",
    headers: {
      "Content-Type": "application/json; charset=UTF-8"
    },
    body: JSON.stringify(formData),
  })
    .then((response) => response.json())
    .then((data) => {
      const erreurs = data.errors || data.description;
      if (erreurs) {
        console.log(":::::")
        console.log(erreurs)
        console.log(":::::")
        // addToCartErrors(erreurs);
        e.target.querySelector('[type="submit"]').disabled = false;
        return false;
      } else {
        // hideAddToCartErrors();
      }
      // console.log(JSON.stringify(Object.fromEntries(new FormData(e.target))))
      updateCart(data);
      document.documentElement.classList.add("cart-drawer");
      e.target.querySelector('[type="submit"]').disabled = false;
      document.querySelectorAll('.product-card-pop:not(.hidden)').forEach((el) => {
        el.classList.add('hidden');
      });
    })
    .catch((error) => {
      console.error("Erreur :", error);
    });
}

/*
function addToCartErrors(message) {
  document.querySelector(".product_errors").classList.remove("hidden");
  document.querySelector(".product_errors_message").textContent = message;
  return false;
}
*/

/*
function hideAddToCartErrors() {
  document.querySelector(".product_errors").classList.add("hidden");
}
*/

function scrolling(e) {
  if(window.innerWidth>=1024) {
    document.querySelectorAll('.parent_li').forEach(el => {
      el.dispatchEvent(new Event("mouseleave"))
      el.classList.add('pointer-events-none')
      setTimeout(() => el.classList.remove('pointer-events-none'), 100)
    })
    document.documentElement.classList.remove('menu')
    if (window.scrollY<200) document.documentElement.classList.remove("mini")
    else document.documentElement.classList.add("mini")
  }
  /*
  let scrollTop = window.pageYOffset || document.documentElement.scrollTop;
  window.pageYOffset > 100 && scrollTop > lastScrollTop
    ? document.documentElement.classList.add("scroll-down")
    : document.documentElement.classList.remove("scroll-down");
  lastScrollTop = scrollTop <= 0 ? 0 : scrollTop;
  */
}

function plusQuantity(e, maxStock) {
  e.parentNode
    .querySelector('[onclick^="minQuantity"]')
    .classList.remove("off");
  var currentValue = e.parentNode.querySelector("input").value;
  if (currentValue == maxStock) return;
  currentValue++;
  e.parentNode.querySelector("input").value = currentValue;
  if (currentValue == maxStock)
    e.parentNode
      .querySelector('[onclick^="plusQuantity"]')
      .classList.add("off");
}

function minQuantity(e) {
  e.parentNode
    .querySelector('[onclick^="plusQuantity"]')
    .classList.remove("off");
  var currentValue = e.parentNode.querySelector("input").value;
  if (currentValue == 1) return;
  currentValue--;
  if (currentValue == 1)
    e.parentNode.querySelector('[onclick^="minQuantity"]').classList.add("off");
  e.parentNode.querySelector("input").value = currentValue;
}

window.updateCart = () => {
  document.querySelector("#cart-drawer")?.classList.add("loading");
  fetch(window.location.href)
    .then((response) => {
      if (!response.ok) {
        throw new Error("Pas de réponse réseau " + response.statusText);
      }
      return response.text();
    })
    .then((html) => {
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, "text/html");
      const cartDrawer = doc.querySelector("#cart-drawer");
      if (cartDrawer) {
        document.querySelector("#cart-drawer").innerHTML = cartDrawer.innerHTML;
      } else {
        console.error("#cart-drawer non trouvé sur la page");
      }
      document.querySelector("#cart-drawer")?.classList.remove("loading");
      const swiper = new Swiper(".cart-product_swiper", {
        navigation: {
          prevEl: ".cart-swiper_prev",
          nextEl: ".cart-swiper_next",
        },
        preventClicks: false,
        preventClicksPropagation: false,
        slidesPerView: 1,
      });

      const swiper2 = new Swiper(".cartempty-product_swiper", {
        navigation: {
          prevEl: ".cartempty-swiper_prev",
          nextEl: ".cartempty-swiper_next",
        },
        preventClicks: false,
        preventClicksPropagation: false,
        slidesPerView: 1,
      })
    })
    .catch((error) => {
      console.error("Erreur fetch :", error);
      document.querySelector("#cart-drawer")?.classList.remove("loading");
    });

  updateCartLink();
};

function fetchCartUpdateQty(el, itemId, quantity) {
  fetch("/cart/update.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
    },
    body: `updates[${itemId}]=${quantity}`,
  })
    .then((response) => {
      if (response.ok) {
        window.updateCart();
        if (quantity === 0) el.closest(".cartDrawer_item").remove();
      } else {
        console.error("Impossible de mettre à jour le cart");
      }
    })
    .catch((error) => console.error("Erreur :", error));
}

window.cartUpdateQuantity = (el) => {
  document.querySelector("#cart-drawer")?.classList.add("loading");
  const itemId = el.closest(".cartDrawer_item").dataset.id;
  const quantity = parseInt(
    el.parentNode.querySelector("[name='quantity']").value,
  );
  fetchCartUpdateQty(el, itemId, quantity);
  return false;
};

window.cartReduceQty = (el) => {
  document.querySelector("#cart-drawer")?.classList.add("loading");
  const itemId = el.closest(".cartDrawer_item").dataset.id;
  const quantity =
    parseInt(el.parentNode.querySelector("[name='quantity']").value) - 1;
  fetchCartUpdateQty(el, itemId, quantity);
  return false;
};

window.cartIncreaseQty = (el) => {
  const maxStock = parseInt(el.getAttribute("max"));
  if (maxStock <= 0) return;

  document.querySelector("#cart-drawer")?.classList.add("loading");
  const itemId = el.closest(".cartDrawer_item").dataset.id;
  let quantity = parseInt(
    el.parentNode.querySelector("[name='quantity']").value,
  );
  quantity++;

  fetch("/cart/update.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
    },
    body: `updates[${itemId}]=${quantity}`,
  })
    .then((response) => response.json())
    .then((data) => {
      const erreurs = data.errors || data.description;
      if (erreurs) {
        el.parentNode.parentNode.parentNode
          .querySelector(".product_errors")
          .classList.remove("hidden");
        el.parentNode.parentNode.parentNode.querySelector(
          ".product_errors_message",
        ).textContent = erreurs;
        document.querySelector("#cart-drawer")?.classList.remove("loading");
        return false;
      } else {
        if(el.parentNode.parentNode.parentNode.querySelector(".product_errors"))
          el.parentNode.parentNode.parentNode
          .querySelector(".product_errors")
          .classList.add("hidden")
        window.updateCart()
      }
    })
    .catch((error) => console.error("Erreur :", error));

  return false;
};

window.removeQty = (el) => {
  document.querySelector("#cart-drawer")?.classList.add("loading");
  const itemId = el.closest(".cartDrawer_item").dataset.id;
  fetchCartUpdateQty(el, itemId, 0);
  return false;
};

window.emptyCart = () => {
  fetch("/cart/clear.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
  })
    .then((response) => response.json())
    .then((data) => {
      console.log("Panier vidé avec succès", data);
    })
    .catch((error) => {
      console.error("Erreur emptyCart :", error);
    });
};

function updateCartLink() {
  fetch("/cart/update")
    .then((response) => response.text())
    .then((data) => {
      let parser = new DOMParser();
      let doc = parser.parseFromString(data, "text/html");

      let newCartContent = doc.querySelector(".open-cart-link").innerHTML;
      document.querySelector(".open-cart-link").innerHTML = newCartContent;
    })
    .catch((error) =>
      console.error("Erreur lors de la mise à jour du panier :", error),
    );
}



/* search */
function showAllSearch() {
  document.querySelector(".predictive-search_button").classList.add("!hidden");
  document.querySelectorAll(".predictive-search__list-item").forEach((el) => {
    if (el.classList.contains("hidden")) el.classList.remove("hidden");
  });
}

function goBackUntilNoSearch() {
  window.history.back();
}

function blocked(e) {
  e.preventDefault();
}

function updateVariantSimple(changedInput) {
  const productCard = changedInput.closest('[data-product-id]');
  if (!productCard) return;
  
  const productId = productCard.dataset.productId;
  const form = changedInput.closest('form');
  if (!form) return;
  
  console.log(`🔄 Mise à jour variante pour ${productId}`);
  
  // Récupérer les variants depuis l'attribut data
  let variants;
  try {
    const variantsData = productCard.getAttribute('data-variants');
    if (variantsData) {
      variants = JSON.parse(variantsData);
    }
  } catch (e) {
    console.error(`❌ Erreur parsing variants pour ${productId}:`, e);
    return;
  }
  
  if (!variants || variants.length === 0) {
    console.log(`❌ Pas de variants pour ${productId}`);
    return;
  }
  
  // Récupérer les options sélectionnées
  const selectedOptions = [];
  const radioGroups = {};
  
  // Grouper les radios par option
  form.querySelectorAll('input[type="radio"]').forEach(input => {
    const optionName = input.name.split('-')[0];
    const optionPosition = parseInt(input.name.split('-')[1]) - 1;
    
    if (!radioGroups[optionPosition]) {
      radioGroups[optionPosition] = [];
    }
    radioGroups[optionPosition].push(input);
  });
  
  // Récupérer les valeurs sélectionnées dans l'ordre
  Object.keys(radioGroups).sort().forEach((position) => {
    const pos = parseInt(position);
    const checkedInput = radioGroups[pos].find(input => input.checked);
    if (checkedInput) {
      selectedOptions[pos] = checkedInput.value;
    }
  });
  
  console.log(`Options sélectionnées:`, selectedOptions);
  
  // Trouver la variante correspondante
  const matchedVariant = variants.find(variant => {
    return selectedOptions.every((selectedValue, index) => {
      const variantOption = variant[`option${index + 1}`];
      return selectedValue && variantOption === selectedValue;
    });
  });
  
  if (matchedVariant) {
    const oldId = form.querySelector('[name="id"]').value;
    form.querySelector('[name="id"]').value = matchedVariant.id;
    console.log(`✅ ${productId}: Variante changée de ${oldId} vers ${matchedVariant.id}`);
  } else {
    console.log(`❌ ${productId}: Aucune variante trouvée pour:`, selectedOptions);
  }
}

// Fonction de compatibilité (au cas où il reste des anciens appels)
function updateVariantGeneric(changedInput, variants, productId) {
  // Rediriger vers la nouvelle fonction
  updateVariantSimple(changedInput);
}